import React from "react";
import { Dropdown, IDropdownOption, Stack, mergeStyles } from "@fluentui/react";
import { styles } from "../ExperimentDetailsForm/experimentDetailsForm.styles";
import { FIELD_TOOLTIPS } from "../ExperimentDetailsForm/ExperimentDetailsValidation/experimentDetailsFormValidation";
import BaseLabelRenderer from "./BaseLabelRenderer";

interface BaseDropdownFieldProps {
  fieldKey: keyof any;
  label: string;
  value: string;
  options: IDropdownOption[];
  isRequired?: boolean;
  isEdit: boolean;
  placeholder?: string;
  errorMessage?: string[];
  onChange: (fieldKey: string, value: string | undefined) => void;
  grow?: boolean;
  className?: string;
}

const BaseDropdownField: React.FC<BaseDropdownFieldProps> = ({
  fieldKey,
  label,
  value,
  options,
  isRequired = false,
  isEdit,
  placeholder = "Select an option...",
  errorMessage,
  onChange,
  grow = false,
  className,
}) => {
  const hasTooltip = FIELD_TOOLTIPS[fieldKey as string];

  const dropdownProps = {
    selectedKey: value || undefined,
    options,
    disabled: !isEdit,
    onChange: isEdit
      ? (e: any, option?: IDropdownOption) =>
          onChange(fieldKey as string, option?.key as string)
      : undefined,
    placeholder,
  };

  const content = (
    <>
      <BaseLabelRenderer
        label={label}
        isRequired={isRequired}
        tooltip={hasTooltip}
      />
      <Dropdown
        {...dropdownProps}
        className={mergeStyles(
          className || styles.experimentDetailsFormColStyle,
          styles.baseDropdown,
        )}
      />
      {errorMessage && errorMessage.length > 0 && (
        <span className={styles.experimentDetailsError}>
          {errorMessage.join("; ")}
        </span>
      )}
    </>
  );

  if (grow) {
    return <Stack grow>{content}</Stack>;
  }

  return content;
};

export default BaseDropdownField;
